import { Component, OnInit, Inject } from '@angular/core';
import { StartUpConfigUiService, ProgressStateUiService } from '../../Core/Services';
import { take } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html'
})
export class ProgressComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private startUpConfigUiService: StartUpConfigUiService,
    private progressStateUiService: ProgressStateUiService,
    @Inject(DOCUMENT) private document: Document) { }
  private counterSource: string;
  private cSig: string;
  private utm_source: string;
  preloaderImageUrl: string;
  ngOnInit(){

    this.startUpConfigUiService.getPreloaderImageUrl()
      .pipe(take(1))
      .subscribe({
        next: (preloaderImageUrl) => {
          this.preloaderImageUrl = preloaderImageUrl;
        }
      });

    const queryParam = this.route.snapshot.queryParamMap;
    this.counterSource = queryParam.get('source');
    this.cSig = queryParam.get('c-sig');
    this.utm_source = queryParam.get('utm_source');
    setTimeout(() => {
      if (this.progressStateUiService.postCjResponseResult$) {
        this.progressStateUiService.postCjResponseResult$.subscribe({
          next: (result) => {
            if (result != null && result.isSuccess) {
              this.redirectToQuotes();
            }
            else if (result.redirectReasonIfFailure == "BOT") {
              //In case of user identified as BOT, redirect user to CMS home page
              this.redirectToCms();
            }
            else {
              //In case of Error/Data Validation Fail/Spam Tracking, Redirect used to CMS
              this.redirectToCms();       //Last change done as per US107806
            }
          }
        });
      } else {
        this.redirectToQuotes();
      }
    }, 3000);
  }

  private redirectToQuotes(): void {
    this.startUpConfigUiService.initialConfig$.pipe(take(1)).subscribe({
      next: (initialConfig) => {
        if (this.cSig == null)
          this.cSig = this.route.snapshot.queryParamMap.get('c-sig');

        const cSigSegment = this.cSig ? `?c-sig=${this.cSig}` : '';
        let utm_campaign = this.route.snapshot.queryParamMap.get('utm_campaign');
        const whiteLabel = (utm_campaign != null && utm_campaign.toLowerCase() == "whitelabels") ? (this.cSig ? `&` : `?`) + `wl=${initialConfig.whiteLabel}` : '';
        const shopsSource = (this.utm_source && this.utm_source.toLowerCase() == "shops") ? (this.cSig || whiteLabel ? `&` : `?`) + `utm_source=${this.utm_source}` : '';
        this.document.location.href = `${initialConfig.urlConfig.quotesStartUpUrl}/${this.counterSource ? this.counterSource : ""}${cSigSegment}${whiteLabel}${shopsSource}`
      }
    });
  }

  private redirectToCj(): void {
    this.startUpConfigUiService.cjUrl$.pipe(take(1)).subscribe({
      next: (cjUrl) => {
        this.document.location.href = cjUrl;
      }
    });
  }

  private redirectToCms(): void {
    this.startUpConfigUiService.cmsUrl$.pipe(take(1)).subscribe(cmsUrl => {
      this.document.location.href = cmsUrl;
    });
  }

}
